import { getLang, setLang, t } from "../i18n";

/** Botão PT | EN. Trocar o idioma recarrega a página. */
export function LangSwitcher({ className = "" }) {
  const lang = getLang();
  const opt = (code, label) => (
    <button
      type="button"
      onClick={() => setLang(code)}
      aria-pressed={lang === code}
      data-testid={`lang-${code}`}
      className={`px-2 py-1 text-[11px] font-mono font-semibold tracking-wider rounded-sm transition-colors ${
        lang === code ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
      }`}
    >
      {label}
    </button>
  );
  return (
    <div
      className={`inline-flex items-center gap-0.5 rounded-md border border-border bg-card/60 p-0.5 ${className}`}
      role="group"
      aria-label={t("Idioma")}
      data-testid="lang-switcher"
    >
      {opt("pt", "PT")}
      {opt("en", "EN")}
    </div>
  );
}

export default LangSwitcher;
